import createReducer from './createReducer';
import createActionsCreators from './createActionCreators';

export const DEFAULTS = {
  immer: true,
  actionCreators: null,
  noActions: false,
};

const getTypeNames = (types) =>
  Object.keys(types).reduce((res, key) => {
    res[key] = key;
    return res;
  }, {});

const getTypesFunction = (types) =>
  Object.entries(types).reduce((res, [key, val]) => {
    res[key] = val.reducer || val;
    return res;
  }, {});

const mergeActionCreators = (types, options) => {
  const actionCreators = Object.entries(types).reduce((res, [key, val]) => {
    if (val.action) {
      res[key] = val.action;
    }
    return res;
  }, {});

  return {
    ...actionCreators,
    ...options.actionCreators,
  };
};

export default (types, initialState = {}, options = {}) => {
  let actions;

  options = { ...DEFAULTS, ...options };

  const reducer = createReducer(getTypesFunction(types), initialState, {
    immer: options.immer,
  });

  if (!options.noActions) {
    const typeNames = getTypeNames(types);
    actions = createActionsCreators(typeNames, mergeActionCreators(types, options));
  }

  return { reducer, actions };
};
